module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-new-connection-action-e5d744c3.svg";